import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_EP_RISPOSTA } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDEpRispostaState extends EntityState<IID_EP_RISPOSTA, ID> { }

@Injectable({
    providedIn: 'root'
  })
  @PersistedStoreConfig({ name: Topics.IID_EP_RISPOSTA })
  @InterfaceDataStore(InterfaceName.RISPOSTA)
  export class IIDEpRispostaStore extends EntityStore<IIDEpRispostaState> {
    constructor() {
      super([]);
    }
  }
  